<template>
  <b-container class="p-0">
    <divalto-codes-form
      @save-code="handleSave"
      @toast-message="showToast"
    />
  </b-container>
</template>

<script>
import { ModalMixin } from '@/mixins';
import DivaltoCodesForm from '@/components/forms/DivaltoCodesForm.vue';

export default {
  name: "DivaltoCodeCreate",
  mixins: [ModalMixin],
  components: {
    DivaltoCodesForm
  },
  props: {
    componentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editableCode: { ...this.componentData }
    };
  },
  watch: {
    componentData: {
      handler(newCode) {
        this.editableCode = { ...newCode };
      },
      deep: true
    }
  },
  methods: {
    handleSave() {   
    },
    showToast({ message, variant }) {
      this.$bvToast.toast(message, {
        variant,
        solid: true,
      });
    },
  }
};
</script>
